<template>

  <div>

    <ItemSearch :enabled.sync="advancedSearch"
                :search.sync="search"
                :options="options"></ItemSearch>

    <div class="elevation-4">

      <v-toolbar flat="flat">
        <v-toolbar-title>{{ options.title }}</v-toolbar-title>
        <ItemQuickSearch :search.sync="quickSearchInput"
                         :advanced.sync="advancedSearch"
                         :placeholder="quickSearchPlaceholder"></ItemQuickSearch>
        <slot name="headerbutton"></slot>
        <v-spacer></v-spacer>
        <v-icon medium="medium" @click="quickSearchLoadData">mdi-refresh</v-icon>
        <v-icon v-if="options.creatable"
                medium="medium"
                @click="$emit('createClicked')">mdi-plus</v-icon>

        <ItemDialog :enabled.sync="dialog"
                    :options="options"
                    :item="editingItem"
                    @created="created">
          <v-icon v-if="options.applyCreate"
                  medium="medium"
                  slot="activator"
                  @click="editingItem = null">mdi-plus</v-icon>
        </ItemDialog>

        <v-icon v-for="(action, index) of options.actions"
                :key="index"
                v-bind="{[action.size || 'medium'] : true}"
                @click="action.onclick">{{ action.icon }}</v-icon>
        <ItemTableOptions :enabled.sync="tableOptions"
                          :options="options">
          <v-icon medium="medium"
                  slot="activator">mdi-settings</v-icon>
        </ItemTableOptions>
      </v-toolbar>

      <ItemTable :options="options"
                 :items="items"
                 :loading="loading"
                 :pagination.sync="pagination"
                 :paginationOptions="paginationOptions"
                 :hidePagination="hidePagination"
                 @edit="edit"
                 @customEdit="customEdit"></ItemTable>
    </div>
  </div>

</template>

<script>

import ItemTable from '@/components/common/ItemTable'
import ItemTableOptions from '@/components/common/ItemTableOptions'
import ItemQuickSearch from '@/components/common/ItemQuickSearch'
import ItemSearch from '@/components/common/ItemSearch'
import ItemDialog from '@/components/common/ItemDialog'
import Vue from 'vue'

export default {
  name: 'ItemPage',
  components: {
    ItemTable,
    ItemTableOptions,
    ItemQuickSearch,
    ItemSearch,
    ItemDialog
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        title: '',
        columns: []
      })
    },
    items: {
      type: Array,
      default: () => []
    },
    searchData: {
      type: Function,
      default: () => () => {}
    },
    quickSearch: {
      type: Function,
      default: () => () => {}
    },
    quickSearchPlaceholder: {
      type: String
    },
    dataReloader: {
      type: Boolean,
      default: false
    },
    loadNoDataAtStart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        sortBy: null,
        descending: null
      },
      paginationOptions: [10, 50, 100],
      loading: false,
      tableOptions: false,
      advancedSearch: false,
      quickSearchInput: '',
      search: {},
      dialog: false,
      editingItem: null,
      editing: false
    }
  },
  computed: {
    hidePagination () {
      return !this.advancedSearch && this.quickSearchInput !== ''
    }
  },
  methods: {
    cleanOptions () {
      for (const column of this.options.columns) {
        Vue.set(column, 'display', column.display !== false)
      }
    },
    loadData (paginationChange) {
      if (!paginationChange) {
        this.pagination.page = 1
      }
      this.loading = true
      let sortBy = this.pagination.sortBy

      if (sortBy) {
        for (const c of this.options.columns) {
          if (sortBy === c.value && c.sort) {
            sortBy = c.sort
            break
          }
        }
      }

      if (this.pagination.descending && sortBy) {
        sortBy += ':desc'
      }

      const params = {
        page: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        ...(this.advancedSearch ? this.search : {})
      }

      if (sortBy) {
        params.sortBy = [sortBy]
      }

      if (params.pageSize === -1) {
        params.pageSize = 100
      }

      this.searchData(params)
        .then(totalItems => {
          this.pagination.totalItems = totalItems
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    quickSearchLoadData () {
      if (this.quickSearchInput.length === 0 || this.advancedSearch) {
        return this.loadData()
      }
      this.loading = true
      this.quickSearch(this.quickSearchInput)
        .then(totalItems => {
          this.pagination.totalItems = totalItems
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    created (val) {
      this.advancedSearch = false
      this.quickSearchInput = val
    },
    edit (index) {
      this.editingItem = JSON.parse(JSON.stringify(this.items[index]))
      this.dialog = true
    },
    customEdit (index) {
      this.$emit('customEdit', this.items[index])
    }
  },
  watch: {
    'pagination.page' () {
      this.loadData(true)
    },
    'pagination.rowsPerPage' () {
      this.loadData(true)
    },
    'pagination.sortBy' () {
      this.loadData(true)
    },
    'pagination.descending' () {
      this.loadData(true)
    },
    'dataReloader' () {
      this.loadData()
    },
    options () {
      this.cleanOptions()
    },
    quickSearchInput () {
      this.quickSearchLoadData()
    },
    search: {
      handler () {
        let previousSearch = JSON.stringify(this.search)
        setTimeout(() => {
          if (previousSearch === JSON.stringify(this.search)) {
            this.loadData()
          }
        }, 300)
      },
      deep: true
    },
    advancedSearch () {
      this.quickSearchLoadData()
    }
  },
  mounted () {
    this.cleanOptions()
    if (!this.loadNoDataAtStart) {
      this.loadData()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/ItemPage.vue